var _rect, _rect2, _path, _path2, _path3, _line, _path4, _line2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGrid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 31,
    height: 31,
    rx: 3.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 31,
    height: 31,
    rx: 3.5,
    stroke: "#DEDEDE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 9.33398L12 22.6673",
    stroke: "#545454"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 9.33398L16 13.4877M16 22.6673L16 18.7509M16 14.628L16 17.6105",
    stroke: "#545454"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20 9.33398L20 22.6673",
    stroke: "#545454"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 9.25098,
    y1: 11.8379,
    x2: 22.5843,
    y2: 11.8379,
    stroke: "#545454"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.91748 16.1562H12.2508H13.0841H13.4849M22.2508 16.1562H20.5841H19.7508H18.6019M14.5667 16.1562H17.52",
    stroke: "#545454"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 8.91748,
    y1: 20.1699,
    x2: 22.2508,
    y2: 20.1699,
    stroke: "#545454"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrid);
export default __webpack_public_path__ + "static/media/grid.cca9f95559a3eaaa9d6b17e7632c756c.svg";
export { ForwardRef as ReactComponent };